module.exports = __webpack_public_path__ + "img/icon-sort.bc8edd9a.svg";